import CookieUtils from 'PyzShopUi/scripts/utils/cookieUtils';
import { SMART_SUGGEST_COOKIE_NAME } from 'PyzShopUi/scripts/search-suggestion/constants';
import { PARAM_SEARCH_TERM } from 'PyzShopUi/scripts/shop-ui/components/search-page/constants';

const PARAM_CC_TYPE = 'ccaType';
const PARAM_CC_TERM = 'ccaTerm';

//TODO: For remove after the A/B testing
class EtrackerCCAttributes {
    private readonly isSmartSuggestExist: boolean;

    public constructor() {
        this.isSmartSuggestExist = CookieUtils.getCookieValue(SMART_SUGGEST_COOKIE_NAME) !== '';
    }

    public enterRedirectWithCCAttributes(searchUrl: URL, searchValue: string): void {
        if (!this.isSmartSuggestExist) {
            searchUrl.searchParams.append(PARAM_SEARCH_TERM, searchValue);
            window.location.href = searchUrl.toString();

            return;
        }

        searchUrl.searchParams.append(PARAM_SEARCH_TERM, searchValue);
        searchUrl.searchParams.append(PARAM_CC_TYPE, 'enter');
        searchUrl.searchParams.append(PARAM_CC_TERM, searchValue);

        window.location.href = searchUrl.toString();
    }

    public prepareClickCCAttributes(searchUrl: URL, searchValue: string): void {
        if (!this.isSmartSuggestExist) {
            return;
        }

        searchUrl.searchParams.append(PARAM_CC_TYPE, 'click');
        searchUrl.searchParams.append(PARAM_CC_TERM, searchValue);
    }
}

export const etrackerCCAttributes = new EtrackerCCAttributes();
